// Avatar initials, derived as the admin export does (design D:8878 `actorInitials`):
// the first letter of each of the first two words — "AKM Aminul Islam" → "AA",
// not first + last. Used by the header account pill and the account menu.

export function initialsOf(name: string | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '·';
  return words
    .slice(0, 2)
    .map((w) => Array.from(w)[0] ?? '')
    .join('')
    .toUpperCase();
}
